import { render, staticRenderFns } from "./AwardItem.vue?vue&type=template&id=669728ee"
import script from "./AwardItem.vue?vue&type=script&lang=js"
export * from "./AwardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports